import React, { SetStateAction } from 'react'
import classes from './Form.module.sass'
import { Button } from '../../../../../../../../common/components/button/Button'
import { Loader } from '../../../../../../../../common/components/loader/Loader'
import { SearchSelect } from '../../../../../../../../common/components/searchSelect/SearchSelect'
import { Input } from '../../../../../../../../common/components/input/Input' // 👈 добавить
import { useForm } from './hooks/useForm'
import { Schedule } from '../../../../../../../../common/components/schedule/Schedule'
import { Toggle } from '../../../../../../../../common/components/toggle/Toggle'
import { createTypeSelectList } from '../../../../../../../../common/utils/functions/createTypeSelectList'
import { ClusterTypes, LegalEntityType } from '../../../../../../../../common/types/enums' // 👈 добавить LegalEntityType
import {
  clusterTypeToText,
  legalEntityTypeToText,
} from '../../../../../../../../common/utils/functions/enumToText' // 👈 добавить legalEntityTypeToText

type Props = {
  getClusters: () => void
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  loading: boolean
  setLoading: React.Dispatch<SetStateAction<boolean>>
}

export const Form = ({ getClusters, setModalActive, setLoading, loading }: Props) => {
  const {
    generateCluster,
    message,
    data,
    setDirty,
    inputHandler,
    toggleAction,
    setData,
    getValidationResult,
    disabled,
  } = useForm(getClusters, setModalActive, setLoading, loading)

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.title}>генерация кластера и ключа доступа</div>
        {loading ? (
          <div className={classes.loaderContainer}>
            <Loader />
            <div className={classes.message}>{message}</div>
          </div>
        ) : (
          <>
            <SearchSelect
              onBlur={setDirty}
              fieldName="type"
              options={createTypeSelectList(ClusterTypes, clusterTypeToText)}
              value={data.type}
              onChangeHandler={inputHandler}
              type="text"
              placeholder="Выберите тип кластера"
              itemValidationResult={getValidationResult('type')}
            />

            {/* 👇 ЮРИДИЧЕСКИЕ ДАННЫЕ */}
            <div className={classes.legalSection}>
              <div className={classes.sectionTitle}>Юридические данные</div>

              <SearchSelect
                onBlur={setDirty}
                fieldName="legalEntityType"
                options={createTypeSelectList(LegalEntityType, legalEntityTypeToText).filter(
                  (el) => Number(el.value) !== -1, // убираем UNSET из списка выбора
                )}
                value={data.legalEntityType}
                onChangeHandler={inputHandler}
                type="text"
                placeholder="Выберите организационно-правовую форму"
                itemValidationResult={getValidationResult('legalEntityType')}
              />

              <Input
                type={'text'}
                fieldName={'legalName'}
                value={data.legalName || ''}
                placeHolder={'Название организации'}
                onChangeHandler={inputHandler}
                itemValidationResult={getValidationResult('legalName')}
                onBlur={setDirty}
              />

              <Input
                type={'text'}
                fieldName={'phone_number'}
                value={data.phone_number || ''}
                placeHolder={'Телефон горячей линии'}
                onChangeHandler={inputHandler}
                itemValidationResult={getValidationResult('phone_number')}
                onBlur={setDirty}
              />

              <Input
                type={'text'}
                fieldName={'legalInn'}
                value={data.legalInn || ''}
                placeHolder={'ИНН'}
                onChangeHandler={inputHandler}
                itemValidationResult={getValidationResult('legalInn')}
                onBlur={setDirty}
              />
            </div>

            <div className={classes.toggleContainer}>
              <Toggle
                id="withDelivery"
                onChange={() => toggleAction('withDelivery')}
                checked={data.withDelivery}
              />
              <div>Есть доставка</div>
            </div>

            {data.schedule && data.withDelivery && (
              <Schedule title="Режим работы доставки" data={data} setData={setData} />
            )}

            <div className={classes.description}>
              После нажатия кнопки подтверждения, для вас будет сгенерирован кластер для торговых
              точек. Кластер - единый узел для вашего вида бизнеса, связанный с одним,
              предоставленым вам, веб сайтом и мобильным приложением. Если у вас несколько видов
              бизнеса - обратитесь в поддержку. После выполнения генерации и активации сотрудником
              вам станут доступны разделы каталога и вы можете приступить к их наполнению
            </div>
          </>
        )}
      </div>

      <div className={classes.button}>
        {!loading && <Button text="Сгенерировать" onClick={generateCluster} disabled={disabled} />}
      </div>
    </div>
  )
}
